import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import _ from 'lodash';

import { loadState, saveState } from './services/storage';

import comprobantesSlice, { initialState as comprobantesState } from './features/comprobantes/comprobantesSlice';
import imponiblesSlice, { initialState as imponiblesState } from './features/imponibles/imponiblesSlice';
import loginSlice, { initialState as LoginState } from './features/login/loginSlice';
import preguntasSlice, { initialState as PreguntasState } from './features/preguntas/preguntasSlice';
import notificacionesSlice, {
  initialState as NotificacionesState
} from './features/notificaciones/notificacionesSlice';
import planesSlice, { initialState as PlanesState } from './features/planes/planesSlice';
import cuotasSlice, { initialState as CuotasState } from './features/cuentacorriente/ctaCorrienteSlice';
import declaracionSlice, { initialState as DeclaracionState } from './features/ddjj/decJuradaSlice';
import dashboardSlice, { initialState as DashboardState } from './features/dashboard/dashboardSlice';
import paymentsSlice, { initialState as PaymentsState } from './features/payments/paymentsSlice';
import mailingSlice, { initialState as MailingState } from './features/mailing/mailingSlice';
import offlineImponibleSlice, {
  initialState as OfflineImponiblesState
} from './features/offlineImponible/offlineImponibleSlice';
import expirationsSlice, { initialState as ExpirationsState } from './features/expirations/expirationsSlice';
import profileSlice, { initialState as profileState } from './features/profile/profileSlice';
import debitSlice, { initialState as DebitState } from './features/debit/debitSlice';

const initialState = {
  comprobantes: comprobantesState,
  imponibles: imponiblesState,
  login: LoginState,
  preguntas: PreguntasState,
  notificaciones: NotificacionesState,
  planes: PlanesState,
  cuotas: CuotasState,
  declaracion: DeclaracionState,
  dashboard: DashboardState,
  mailing: MailingState,
  payments: PaymentsState,
  offlineImponibles: OfflineImponiblesState,
  expirations: ExpirationsState,
  profile: profileState,
  debit: DebitState,
};

const initialData = _.merge({}, initialState, loadState());

export const store = configureStore({
  reducer: {
    comprobantes: comprobantesSlice,
    imponibles: imponiblesSlice,
    login: loginSlice,
    preguntas: preguntasSlice,
    notificaciones: notificacionesSlice,
    planes: planesSlice,
    cuotas: cuotasSlice,
    declaracion: declaracionSlice,
    dashboard: dashboardSlice,
    mailing: mailingSlice,
    payments: paymentsSlice,
    offlineImponibles: offlineImponibleSlice,
    expirations: expirationsSlice,
    profile: profileSlice,
    debit: debitSlice,
  },
  preloadedState: initialData,
});

store.subscribe(() => {
  const { login } = store.getState();
  saveState({ login });
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
